import React, { useState } from 'react';
import { Modal, Box, TextField } from '@mui/material';
import Button from '@/components/CustomButtons/Button';
import { modalStyle } from '@/views/Clients/Claim';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';

export default function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  children,
  showCommentField = false,
  commentLabel = 'Comment',
  commentPlaceholder = 'Enter your comment...',
  commentRequired = false,
}) {
  const [comment, setComment] = useState('');
  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <Box
        sx={modalStyle}
        style={{
          width: '500px',
        }}
        className='makeStyles-card-96'
        noValidate
        autoComplete='off'>
        <CardHeader style={{ transform: 'translateY(-50%)' }} color='primary'>
          <h6>Confirm Action</h6>
        </CardHeader>
        <CardBody>
          {children}
          {showCommentField && (
            <TextField
              fullWidth
              label={commentLabel}
              placeholder={commentPlaceholder}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              multiline
              rows={3}
              required={commentRequired}
              variant='outlined'
              style={{ marginTop: '20px' }}
            />
          )}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginTop: '30px',
            }}>
            <Button
              color='rose'
              onClick={() => {
                setComment('');
                onClose(false);
              }}
              type='button'
              variant='contained'>
              Cancel
            </Button>
            <Button
              color='primary'
              onClick={() => {
                if (commentRequired && !comment.trim()) {
                  return;
                }
                onConfirm(true, comment);
                setComment('');
              }}
              type='button'
              variant='contained'
              disabled={commentRequired && !comment.trim()}
              style={{ marginLeft: '10px' }}>
              Confirm
            </Button>
          </div>
        </CardBody>
      </Box>
    </Modal>
  );
}
